import Link from '@amzn/meridian/link';
import React, { FC } from 'react';
import { Trans } from 'react-i18next';
import loginPage from '../../../assets/loginPage.png';
import passwordResetPage from '../../../assets/passwordResetPage.png';
import { SiteHelpCallback } from '../../../constants';
import { useTranslation } from '../../blocks';
import { HelpBody, HelpBullet, HelpImage, HelpIndent, HelpSubheading, HelpTitle } from './HelpElements';

const FrequentlyAskedQuestionsHelp: FC<SiteHelpCallback> = () => {
    const { t } = useTranslation('frequentlyAskedQuestionsHelp');

    return (
        <>
            <HelpTitle>{t('frequentlyAskedQuestionsHelp_Title')}</HelpTitle>

            <HelpSubheading>{t('frequentlyAskedQuestionsHelp_receivedPartialCreditQuestion')}</HelpSubheading>
            <HelpBody>{t('frequentlyAskedQuestionsHelp_receiptOfEntireShipmentAnswer')}</HelpBody>

            <HelpSubheading>{t('frequentlyAskedQuestionsHelp_unauthorizedProductQuestion')}</HelpSubheading>
            <HelpBody>{t('frequentlyAskedQuestionsHelp_unauthorizedProductAnswer')}</HelpBody>

            <HelpSubheading>{t('frequentlyAskedQuestionsHelp_whoContactQuestion')}</HelpSubheading>
            <HelpBody>
                <Trans
                    i18nKey={'frequentlyAskedQuestionsHelp_whoContactAnswer'}
                    ns={'frequentlyAskedQuestionsHelp'}
                    components={{ mailto: <Link href={'mailto:acme-kor-ar@amazon.com'}>{''}</Link> }}
                />
            </HelpBody>

            <HelpSubheading>{t('frequentlyAskedQuestionsHelp_creditQuicklyAndAccuratelyQuestion')}</HelpSubheading>
            <HelpBody>{t('frequentlyAskedQuestionsHelp_creditQuicklyAndAccuratelyAnswer')}</HelpBody>
            <HelpIndent>
                <HelpBullet marker={'✓'}>{t('frequentlyAskedQuestionsHelp_creditQAA_Step1')}</HelpBullet>
                <HelpBullet marker={'✓'}>{t('frequentlyAskedQuestionsHelp_creditQAA_Step2')}</HelpBullet>
                <HelpBullet marker={'✓'}>{t('frequentlyAskedQuestionsHelp_creditQAA_Step3')}</HelpBullet>
                <HelpBullet marker={'✓'}>{t('frequentlyAskedQuestionsHelp_creditQAA_Step4')}</HelpBullet>
                <HelpBullet marker={'✓'}>{t('frequentlyAskedQuestionsHelp_creditQAA_Step5')}</HelpBullet>
            </HelpIndent>

            <HelpSubheading>{t('frequentlyAskedQuestionsHelp_loginQuestion')}</HelpSubheading>
            <HelpBody>
                <Trans
                    i18nKey={'frequentlyAskedQuestionsHelp_loginAnswer1'}
                    ns={'frequentlyAskedQuestionsHelp'}
                    components={{ url: <Link href={'https://reseller.amazon.com/account/sign-in'}>{''}</Link> }}
                />
            </HelpBody>
            <HelpImage size={'medium'} src={loginPage} />
            <HelpBody>
                <Trans
                    i18nKey={'frequentlyAskedQuestionsHelp_loginAnswer2'}
                    ns={'frequentlyAskedQuestionsHelp'}
                    components={{ url: <Link href={'https://reseller.amazon.com/account/reset-password'}>{''}</Link> }}
                />
            </HelpBody>
            <HelpImage size={'medium'} src={passwordResetPage} />
            <HelpBody>{t('frequentlyAskedQuestionsHelp_loginAnswer3')}</HelpBody>
        </>
    );
};

export { FrequentlyAskedQuestionsHelp };
